import { Component, effect, inject } from '@angular/core';
import { SharedSignalsService } from '../../../common/services/shared-signals.service';

@Component({
  selector: 'taly-payment-option',
  templateUrl: './taly-payment-option.component.html',
  styleUrls: ['./taly-payment-option.component.scss'],
  standalone: false,
})
export class TalyPaymentOptionComponent {
  transferSignal = inject(SharedSignalsService);

  textDirection!: string;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }
}
